import { Button, Modal } from '@/components';
import { R } from '../resources/NewbornResources.resx';

export type HaveYouGivenBirthModalProps = {
    onClose: () => void;
    onStillPregnant: () => void;
    onBabyIsBorn: () => void;
    isPending: boolean;
};

export const HaveYouGivenBirthModal = ({
    onClose,
    onStillPregnant,
    onBabyIsBorn,
    isPending,
}: HaveYouGivenBirthModalProps) => {
    return (
        <Modal onClose={onClose}>
            <div className="flex flex-col items-center">
                <img
                    src="/images/icons_shape/figure-baby.svg"
                    alt=""
                    className="mb-6"
                />

                <h2 className="text-primary-blue mb-4 self-start">
                    {R.HaveYouGivenBirthTitle}
                </h2>

                <p className="mt-0 mb-4 text-gray-900">
                    {R.HaveYouGivenBirthParagraph1}
                </p>

                <p className="mt-0 mb-6 text-gray-900">
                    {R.HaveYouGivenBirthParagraph2}
                </p>

                <div className="flex gap-4 self-end">
                    <Button
                        variant="secondary"
                        outline
                        onClick={onStillPregnant}
                        disabled={isPending}
                    >
                        {R.StillPregnantButtonText}
                    </Button>
                    <Button
                        variant="secondary"
                        outline
                        onClick={onBabyIsBorn}
                        disabled={isPending}
                    >
                        {R.BabyBornButtonText}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};
